module.exports = __webpack_public_path__ + "static/connected-world-413ce966295a883e5a766ed0f795e66f.svg";